import { openModal } from '../helpers/useModal'
import { type_GM_STATE } from '../../helpers'
import { HeartIcon } from '../icons/HeartIcon'
import { wishlistProviderService } from '../helpers/provider.service'
import { useWishlistListForHandle } from '../helpers/list-store'

type props = {
  productId: number
  productHandle: string | null
  productTemplate: string | null
}

declare var GM_STATE: type_GM_STATE

export function WishlistItem({ productId, productHandle, productTemplate }: props) {
  const { redirect, ignore } = GM_STATE.wishlist.productTemplates
  const currentList = useWishlistListForHandle(productHandle)

  if (!productId || !productHandle) {
    return null
  }

  const isRedirectTemplate = productTemplate && redirect.includes(productTemplate)
  const isIgnoreTemplate = productTemplate && ignore.includes(productTemplate)
  if (isIgnoreTemplate) return null

  const wishlistSlideoutEl = document.querySelector('.js-wishlist-product-slideout')
  const rootUrlWithoutSlash = window.routes.rootUrlWithoutSlash

  const openAccountSlideout = () => {
    sessionStorage.setItem('returnTo', `/products/${productHandle}`)
    openModal('account-slideout')
  }

  const handleClick = async () => {
    if (isRedirectTemplate) {
      location.href = `${rootUrlWithoutSlash}/products/${productHandle}`
    } else {
      const loggedIn = await wishlistProviderService.isLoggedIn()

      if (!loggedIn) {
        openAccountSlideout()
        return
      }

      openSlideout()
    }
  }

  const openSlideout = () => {
    wishlistSlideoutEl?.setAttribute('product-id', productId.toString())
    wishlistSlideoutEl?.setAttribute('product-handle', productHandle)
    productTemplate && wishlistSlideoutEl?.setAttribute('product-template', productTemplate)
    wishlistSlideoutEl?.setAttribute('open-source', 'plp')
    openModal('wishlist-product-slideout')
  }

  return (
    <button className="wishlist_icon" type="button" onClick={handleClick}>
      <HeartIcon className={currentList ? 'fill-ink' : 'text-subdued'} />
    </button>
  )
}
